import styled from 'styled-components';
import { Autocomplete } from '@mui/material';

export const StyleAutoComplete = styled(Autocomplete)`
  .MuiInputBase-root {
    border-radius: 5px !important;
    min-height: 3rem;
    height: auto;
    max-height: none;
    width: 100%;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 10px;
    overflow: visible;
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: #d9d9d9 !important;
  }

  & .MuiOutlinedInput-root {
    min-height: 3rem;
    height: auto;
    max-height: none;
    flex-wrap: wrap;
    align-items: flex-start;
    overflow: visible;
    &.Mui-focused fieldset {
      border-color: #fe2f67 !important;
    }
    #tags-outlined::placeholder {
      font-size: 1.5vh;
      padding: 5px 5px;
    }
    .MuiAutocomplete-tag {
      background-color: #ffdde6;
      border-radius: 10px;
      color: #262626;
      font-weight: 600;
      border: none;
      margin: 2px 4px 2px 0;
      max-width: 100%;
      white-space: normal;
      overflow-wrap: anywhere;
    }
  }
  input {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    outline: none !important;
    padding-left: 0 !important;
  }
  .MuiAutocomplete-clearIndicator {
    color: #fe2f67 !important;
  }
  /* Opciones seleccionadas en el dropdown (máxima especificidad) */
  && .MuiAutocomplete-option[aria-selected="true"],
  && .MuiAutocomplete-option[aria-selected="true"].Mui-focused,
  && .MuiAutocomplete-option[aria-selected="true"]:hover {
    background-color: #ffdde6 !important;
    color: #262626 !important;
  }
  /* Desactivar el azul de hover/focus en seleccionadas */
  && .MuiAutocomplete-option[aria-selected="true"].Mui-focused,
  && .MuiAutocomplete-option[aria-selected="true"]:hover {
    background-color: #ffdde6 !important;
  }
`;

export const StyleNaicsLabel = styled.p`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;

export const StyleDatePicker = styled.div`
  .MuiOutlinedInput-root {
    border-radius: 5px !important;
    min-height: 3rem;
    height: 3rem;
    max-height: 3rem;
    width: 100%;
    margin-bottom: 10px;
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: #d9d9d9 !important;
  }
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #fe2f67 !important;
  }
  .MuiSvgIcon-root {
    color: #fe2f67 !important;
  }
  /* Calendar */
  .MuiPickersDay-root {
    border: none !important;
    color: #262626;
    background: transparent;
    transition: background 0.2s, color 0.2s;
  }
  &&& .MuiPickersDay-root.Mui-selected,
  &&& .MuiPickersDay-root:focus,
  &&& .MuiPickersDay-root:hover {
    background: #fe2f67 !important;
    color: #fff !important;
    border-radius: 50% !important;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }
  &&& .MuiPickersDay-root.Mui-selected {
    background: #fe2f67 !important;
    color: #fff !important;
    border-radius: 50%;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }
  .MuiPickersDay-root.Mui-disabled {
    color: #ccc !important;
    background: transparent !important;
  }
  .MuiPickersCalendarHeader-label, .MuiPickersCalendarHeader-switchViewButton, .MuiPickersArrowSwitcher-root {
    color: #fe2f67 !important;
  }
  .MuiPickersArrowSwitcher-button {
    color: #fe2f67 !important;
  }
  /* Hide the inner border of the DatePicker text input */
  input.MuiInputBase-input {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    background: transparent !important;
  }
  && .MuiInputLabel-root {
    color: #8692a6 !important;
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
    min-width: 0 !important;
    width: auto !important;
    font-weight: 400 !important;
  }
  && .MuiInputLabel-root.Mui-focused,
  && .MuiInputLabel-root.MuiInputLabel-shrink {
    color: #fe2f67 !important;
    font-weight: 600 !important;
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
    min-width: 0 !important;
    width: auto !important;
  }
  .MuiInputBase-input {
    font-size: 1.1rem !important;
  }
`;
